import type { ComponentType } from 'react';
import { lazyWithRetry } from '@/shared/utils/lazyWithRetry';
import { RouteStalePanel } from './StaleAppPanel';

/** 路由頁面專用的 lazy：載入失敗時，在版面內容區顯示「頁面已更新」面板 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyRoute<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) {
    return lazyWithRetry(factory, RouteStalePanel);
}
